import { ChatMessageVerificationError } from '../../../errors/ChatMessageVerificationError';
import { showAlert } from '../../../slices/alertSlice';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageNeedConfirmPhone } from '../actions';
import { EFirstMessageResponseStatus, IAssertDependencies, TFirstMessageResponse } from '../types';

export const assertNeedConfirmPhoneStatus =
  (response: TFirstMessageResponse, { domain, telemetry }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.NeedConfirmPhone) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendNeedConfirmPhone);

      dispatch(setFirstMessageNeedConfirmPhone());
      dispatch(showAlert({ message: 'Необходимо подтвердить телефон' }));

      const error = new ChatMessageVerificationError({
        message: 'Не удалось отправить первое сообщение: отправитель не подтвердил телефон',
        domain,
        details: { errorCode: response.status },
      });

      logger.warning(error);
    }
  };
